import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class TeamService {
  static async access() {
    try {
      const { data } = await api.get('/team/access');
      return data; // { allowed, used, max }
    } catch {
      return { allowed: false, used: 0, max: 0 };
    }
  }
  static async list() {
    const { data } = await api.get('/team');
    return data.data || [];
  }
  static async add(name, email) {
    const { data } = await api.post('/team', { name, email });
    return data; // { data: member, temp_password }
  }
  static async update(id, payload) {
    const { data } = await api.patch(`/team/${id}`, payload);
    return data.data;
  }
  static async resetPassword(id) {
    const { data } = await api.post(`/team/${id}/reset-password`);
    return data.temp_password;
  }
  static async remove(id) {
    await api.delete(`/team/${id}`);
  }
}

export default TeamService;
